import { PageTimePeriod } from 'src/types/page-time-period.enum';
import SpendingBudgetWrapper from './SpendingBudget';

export default function YearlySpending(): JSX.Element {
    return SpendingBudgetWrapper({
        timePeriod: PageTimePeriod.LAST_YEAR
    });
}
